// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/directory/v1/directory.proto" (package "c1.api.directory.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Any } from "../../../../google/protobuf/any";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * The fields to be included in the directory response.
 *
 * @generated from protobuf message c1.api.directory.v1.DirectoryExpandMask
 */
export interface DirectoryExpandMask {
    /**
     * An array of fields to be included in the directory response.
     *
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * This object indicates that an app is also a directory.
 *
 * @generated from protobuf message c1.api.directory.v1.Directory
 */
export interface Directory {
    /**
     * The ID of the app associated with the directory.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The datetime, in RFC3339 format, of when the Directory was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the Directory was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the Directory was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 4
     */
    deletedAt?: Timestamp;
    /**
     * The account filter for the directory.
     *
     * @generated from protobuf oneof: account_filter
     */
    accountFilter: {
        oneofKind: "all";
        /**
         * @generated from protobuf field: c1.api.directory.v1.DirectoryAccountFilterAll all = 101
         */
        all: DirectoryAccountFilterAll;
    } | {
        oneofKind: "celExpression";
        /**
         * @generated from protobuf field: c1.api.directory.v1.DirectoryAccountFilterCel cel_expression = 102
         */
        celExpression: DirectoryAccountFilterCel;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.directory.v1.DirectoryAccountFilterAll
 */
export interface DirectoryAccountFilterAll {
}
/**
 * @generated from protobuf message c1.api.directory.v1.DirectoryAccountFilterCel
 */
export interface DirectoryAccountFilterCel {
    /**
     * @generated from protobuf field: string expression = 1
     */
    expression: string;
}
/**
 * @generated from protobuf message c1.api.directory.v1.DirectoryRef
 */
export interface DirectoryRef {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
}
/**
 * The directory view contains a directory and an app_path which is a JSONPATH set to the location in the expand mask that the expanded app will live if requested by the expander.
 *
 * @generated from protobuf message c1.api.directory.v1.DirectoryView
 */
export interface DirectoryView {
    /**
     * The directory object being returned by the request.
     *
     * @generated from protobuf field: c1.api.directory.v1.Directory directory = 1
     */
    directory?: Directory;
    /**
     * JSONPATH expression indicating the location of the App object in the array.
     *
     * @generated from protobuf field: string app_path = 2
     */
    appPath: string;
}
/**
 * The Directory Service Get Response returns a directory view with a directory and JSONPATHs indicating the
 * location in the expanded array that items are expanded as indicated by the expand mask in the request.
 *
 * @generated from protobuf message c1.api.directory.v1.DirectoryServiceGetResponse
 */
export interface DirectoryServiceGetResponse {
    /**
     * A view of the directory, contains the serialized directory and paths to objects referenced by the directory.
     *
     * @generated from protobuf field: c1.api.directory.v1.DirectoryView directory_view = 1
     */
    directoryView?: DirectoryView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * Uplevel an app into a full directory.
 *
 * @generated from protobuf message c1.api.directory.v1.DirectoryServiceCreateRequest
 */
export interface DirectoryServiceCreateRequest {
    /**
     * The AppID to make into a directory, providing identities and more for the C1 app.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The list of paths to expand in the return value expanded list.
     *
     * @generated from protobuf field: c1.api.directory.v1.DirectoryExpandMask expand_mask = 2
     */
    expandMask?: DirectoryExpandMask;
    /**
     * @generated from protobuf oneof: account_filter
     */
    accountFilter: {
        oneofKind: "all";
        /**
         * @generated from protobuf field: c1.api.directory.v1.DirectoryAccountFilterAll all = 101
         */
        all: DirectoryAccountFilterAll;
    } | {
        oneofKind: "celExpression";
        /**
         * @generated from protobuf field: c1.api.directory.v1.DirectoryAccountFilterCel cel_expression = 102
         */
        celExpression: DirectoryAccountFilterCel;
    } | {
        oneofKind: undefined;
    };
}
/**
 * The DirectoryServiceCreateResponse message.
 *
 * @generated from protobuf message c1.api.directory.v1.DirectoryServiceCreateResponse
 */
export interface DirectoryServiceCreateResponse {
    /**
     * A view of the directory, contains the serialized directory and paths to objects referenced by the directory.
     *
     * @generated from protobuf field: c1.api.directory.v1.DirectoryView directory_view = 1
     */
    directoryView?: DirectoryView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * Update a directory by app_id.
 *
 * @generated from protobuf message c1.api.directory.v1.DirectoryServiceUpdateRequest
 */
export interface DirectoryServiceUpdateRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The account filter for the directory.
     *
     * @generated from protobuf oneof: account_filter
     */
    accountFilter: {
        oneofKind: "all";
        /**
         * @generated from protobuf field: c1.api.directory.v1.DirectoryAccountFilterAll all = 101
         */
        all: DirectoryAccountFilterAll;
    } | {
        oneofKind: "celExpression";
        /**
         * @generated from protobuf field: c1.api.directory.v1.DirectoryAccountFilterCel cel_expression = 102
         */
        celExpression: DirectoryAccountFilterCel;
    } | {
        oneofKind: undefined;
    };
    /**
     * The list of paths to expand in the return value expanded list.
     *
     * @generated from protobuf field: c1.api.directory.v1.DirectoryExpandMask expand_mask = 2
     */
    expandMask?: DirectoryExpandMask;
}
/**
 * @generated from protobuf message c1.api.directory.v1.DirectoryServiceUpdateResponse
 */
export interface DirectoryServiceUpdateResponse {
    /**
     * A view of the directory, contains the serialized directory and paths to objects referenced by the directory.
     *
     * @generated from protobuf field: c1.api.directory.v1.DirectoryView directory_view = 1
     */
    directoryView?: DirectoryView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.directory.v1.DirectoryServiceGetRequest
 */
export interface DirectoryServiceGetRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: c1.api.directory.v1.DirectoryExpandMask expand_mask = 2
     */
    expandMask?: DirectoryExpandMask;
}
/**
 * DirectoryServiceDeleteRequest is the request message for deleting a directory. It uses URL values for input.
 *
 * @generated from protobuf message c1.api.directory.v1.DirectoryServiceDeleteRequest
 */
export interface DirectoryServiceDeleteRequest {
    /**
     * The app_id of the directory to delete.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
}
/**
 * Empty response with a status code indicating success.
 *
 * @generated from protobuf message c1.api.directory.v1.DirectoryServiceDeleteResponse
 */
export interface DirectoryServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.directory.v1.DirectoryServiceListRequest
 */
export interface DirectoryServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.directory.v1.DirectoryExpandMask expand_mask = 3
     */
    expandMask?: DirectoryExpandMask;
}
/**
 * The DirectoryServiceListResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.directory.v1.DirectoryServiceListResponse
 */
export interface DirectoryServiceListResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.directory.v1.DirectoryView list = 1
     */
    list: DirectoryView[];
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.directory.v1.DirectoryServiceSearchRequest
 */
export interface DirectoryServiceSearchRequest {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.directory.v1.DirectoryExpandMask expand_mask = 4
     */
    expandMask?: DirectoryExpandMask;
    /**
     * The refs to search for.
     *
     * @generated from protobuf field: repeated c1.api.directory.v1.DirectoryRef refs = 5
     */
    refs: DirectoryRef[];
}
/**
 * @generated from protobuf message c1.api.directory.v1.DirectoryServiceSearchResponse
 */
export interface DirectoryServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.directory.v1.DirectoryView list = 1
     */
    list: DirectoryView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryExpandMask$Type extends MessageType<DirectoryExpandMask> {
    constructor() {
        super("c1.api.directory.v1.DirectoryExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<DirectoryExpandMask>): DirectoryExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<DirectoryExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DirectoryExpandMask): DirectoryExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DirectoryExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryExpandMask
 */
export const DirectoryExpandMask = new DirectoryExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Directory$Type extends MessageType<Directory> {
    constructor() {
        super("c1.api.directory.v1.Directory", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 101, name: "all", kind: "message", oneof: "accountFilter", T: () => DirectoryAccountFilterAll },
            { no: 102, name: "cel_expression", kind: "message", oneof: "accountFilter", T: () => DirectoryAccountFilterCel }
        ]);
    }
    create(value?: PartialMessage<Directory>): Directory {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.accountFilter = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<Directory>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Directory): Directory {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 4:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* c1.api.directory.v1.DirectoryAccountFilterAll all */ 101:
                    message.accountFilter = {
                        oneofKind: "all",
                        all: DirectoryAccountFilterAll.internalBinaryRead(reader, reader.uint32(), options, (message.accountFilter as any).all)
                    };
                    break;
                case /* c1.api.directory.v1.DirectoryAccountFilterCel cel_expression */ 102:
                    message.accountFilter = {
                        oneofKind: "celExpression",
                        celExpression: DirectoryAccountFilterCel.internalBinaryRead(reader, reader.uint32(), options, (message.accountFilter as any).celExpression)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Directory, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 4; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.directory.v1.DirectoryAccountFilterAll all = 101; */
        if (message.accountFilter.oneofKind === "all")
            DirectoryAccountFilterAll.internalBinaryWrite(message.accountFilter.all, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.directory.v1.DirectoryAccountFilterCel cel_expression = 102; */
        if (message.accountFilter.oneofKind === "celExpression")
            DirectoryAccountFilterCel.internalBinaryWrite(message.accountFilter.celExpression, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.Directory
 */
export const Directory = new Directory$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryAccountFilterAll$Type extends MessageType<DirectoryAccountFilterAll> {
    constructor() {
        super("c1.api.directory.v1.DirectoryAccountFilterAll", []);
    }
    create(value?: PartialMessage<DirectoryAccountFilterAll>): DirectoryAccountFilterAll {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DirectoryAccountFilterAll>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DirectoryAccountFilterAll): DirectoryAccountFilterAll {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DirectoryAccountFilterAll, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryAccountFilterAll
 */
export const DirectoryAccountFilterAll = new DirectoryAccountFilterAll$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryAccountFilterCel$Type extends MessageType<DirectoryAccountFilterCel> {
    constructor() {
        super("c1.api.directory.v1.DirectoryAccountFilterCel", [
            { no: 1, name: "expression", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DirectoryAccountFilterCel>): DirectoryAccountFilterCel {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expression = "";
        if (value !== undefined)
            reflectionMergePartial<DirectoryAccountFilterCel>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DirectoryAccountFilterCel): DirectoryAccountFilterCel {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string expression */ 1:
                    message.expression = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DirectoryAccountFilterCel, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string expression = 1; */
        if (message.expression !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.expression);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryAccountFilterCel
 */
export const DirectoryAccountFilterCel = new DirectoryAccountFilterCel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryRef$Type extends MessageType<DirectoryRef> {
    constructor() {
        super("c1.api.directory.v1.DirectoryRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<DirectoryRef>): DirectoryRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<DirectoryRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DirectoryRef): DirectoryRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DirectoryRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryRef
 */
export const DirectoryRef = new DirectoryRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryView$Type extends MessageType<DirectoryView> {
    constructor() {
        super("c1.api.directory.v1.DirectoryView", [
            { no: 1, name: "directory", kind: "message", T: () => Directory },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DirectoryView>): DirectoryView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appPath = "";
        if (value !== undefined)
            reflectionMergePartial<DirectoryView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DirectoryView): DirectoryView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.directory.v1.Directory directory */ 1:
                    message.directory = Directory.internalBinaryRead(reader, reader.uint32(), options, message.directory);
                    break;
                case /* string app_path */ 2:
                    message.appPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DirectoryView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.directory.v1.Directory directory = 1; */
        if (message.directory)
            Directory.internalBinaryWrite(message.directory, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string app_path = 2; */
        if (message.appPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryView
 */
export const DirectoryView = new DirectoryView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryServiceGetResponse$Type extends MessageType<DirectoryServiceGetResponse> {
    constructor() {
        super("c1.api.directory.v1.DirectoryServiceGetResponse", [
            { no: 1, name: "directory_view", kind: "message", T: () => DirectoryView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<DirectoryServiceGetResponse>): DirectoryServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<DirectoryServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DirectoryServiceGetResponse): DirectoryServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.directory.v1.DirectoryView directory_view */ 1:
                    message.directoryView = DirectoryView.internalBinaryRead(reader, reader.uint32(), options, message.directoryView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DirectoryServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.directory.v1.DirectoryView directory_view = 1; */
        if (message.directoryView)
            DirectoryView.internalBinaryWrite(message.directoryView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryServiceGetResponse
 */
export const DirectoryServiceGetResponse = new DirectoryServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryServiceCreateRequest$Type extends MessageType<DirectoryServiceCreateRequest> {
    constructor() {
        super("c1.api.directory.v1.DirectoryServiceCreateRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => DirectoryExpandMask },
            { no: 101, name: "all", kind: "message", oneof: "accountFilter", T: () => DirectoryAccountFilterAll },
            { no: 102, name: "cel_expression", kind: "message", oneof: "accountFilter", T: () => DirectoryAccountFilterCel }
        ]);
    }
    create(value?: PartialMessage<DirectoryServiceCreateRequest>): DirectoryServiceCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.accountFilter = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<DirectoryServiceCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DirectoryServiceCreateRequest): DirectoryServiceCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* c1.api.directory.v1.DirectoryExpandMask expand_mask */ 2:
                    message.expandMask = DirectoryExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* c1.api.directory.v1.DirectoryAccountFilterAll all */ 101:
                    message.accountFilter = {
                        oneofKind: "all",
                        all: DirectoryAccountFilterAll.internalBinaryRead(reader, reader.uint32(), options, (message.accountFilter as any).all)
                    };
                    break;
                case /* c1.api.directory.v1.DirectoryAccountFilterCel cel_expression */ 102:
                    message.accountFilter = {
                        oneofKind: "celExpression",
                        celExpression: DirectoryAccountFilterCel.internalBinaryRead(reader, reader.uint32(), options, (message.accountFilter as any).celExpression)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DirectoryServiceCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* c1.api.directory.v1.DirectoryExpandMask expand_mask = 2; */
        if (message.expandMask)
            DirectoryExpandMask.internalBinaryWrite(message.expandMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.directory.v1.DirectoryAccountFilterAll all = 101; */
        if (message.accountFilter.oneofKind === "all")
            DirectoryAccountFilterAll.internalBinaryWrite(message.accountFilter.all, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.directory.v1.DirectoryAccountFilterCel cel_expression = 102; */
        if (message.accountFilter.oneofKind === "celExpression")
            DirectoryAccountFilterCel.internalBinaryWrite(message.accountFilter.celExpression, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryServiceCreateRequest
 */
export const DirectoryServiceCreateRequest = new DirectoryServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryServiceCreateResponse$Type extends MessageType<DirectoryServiceCreateResponse> {
    constructor() {
        super("c1.api.directory.v1.DirectoryServiceCreateResponse", [
            { no: 1, name: "directory_view", kind: "message", T: () => DirectoryView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<DirectoryServiceCreateResponse>): DirectoryServiceCreateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<DirectoryServiceCreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DirectoryServiceCreateResponse): DirectoryServiceCreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.directory.v1.DirectoryView directory_view */ 1:
                    message.directoryView = DirectoryView.internalBinaryRead(reader, reader.uint32(), options, message.directoryView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DirectoryServiceCreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.directory.v1.DirectoryView directory_view = 1; */
        if (message.directoryView)
            DirectoryView.internalBinaryWrite(message.directoryView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryServiceCreateResponse
 */
export const DirectoryServiceCreateResponse = new DirectoryServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryServiceUpdateRequest$Type extends MessageType<DirectoryServiceUpdateRequest> {
    constructor() {
        super("c1.api.directory.v1.DirectoryServiceUpdateRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 101, name: "all", kind: "message", oneof: "accountFilter", T: () => DirectoryAccountFilterAll },
            { no: 102, name: "cel_expression", kind: "message", oneof: "accountFilter", T: () => DirectoryAccountFilterCel },
            { no: 2, name: "expand_mask", kind: "message", T: () => DirectoryExpandMask }
        ]);
    }
    create(value?: PartialMessage<DirectoryServiceUpdateRequest>): DirectoryServiceUpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.accountFilter = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<DirectoryServiceUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DirectoryServiceUpdateRequest): DirectoryServiceUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* c1.api.directory.v1.DirectoryAccountFilterAll all */ 101:
                    message.accountFilter = {
                        oneofKind: "all",
                        all: DirectoryAccountFilterAll.internalBinaryRead(reader, reader.uint32(), options, (message.accountFilter as any).all)
                    };
                    break;
                case /* c1.api.directory.v1.DirectoryAccountFilterCel cel_expression */ 102:
                    message.accountFilter = {
                        oneofKind: "celExpression",
                        celExpression: DirectoryAccountFilterCel.internalBinaryRead(reader, reader.uint32(), options, (message.accountFilter as any).celExpression)
                    };
                    break;
                case /* c1.api.directory.v1.DirectoryExpandMask expand_mask */ 2:
                    message.expandMask = DirectoryExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DirectoryServiceUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* c1.api.directory.v1.DirectoryExpandMask expand_mask = 2; */
        if (message.expandMask)
            DirectoryExpandMask.internalBinaryWrite(message.expandMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.directory.v1.DirectoryAccountFilterAll all = 101; */
        if (message.accountFilter.oneofKind === "all")
            DirectoryAccountFilterAll.internalBinaryWrite(message.accountFilter.all, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.directory.v1.DirectoryAccountFilterCel cel_expression = 102; */
        if (message.accountFilter.oneofKind === "celExpression")
            DirectoryAccountFilterCel.internalBinaryWrite(message.accountFilter.celExpression, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryServiceUpdateRequest
 */
export const DirectoryServiceUpdateRequest = new DirectoryServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryServiceUpdateResponse$Type extends MessageType<DirectoryServiceUpdateResponse> {
    constructor() {
        super("c1.api.directory.v1.DirectoryServiceUpdateResponse", [
            { no: 1, name: "directory_view", kind: "message", T: () => DirectoryView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<DirectoryServiceUpdateResponse>): DirectoryServiceUpdateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<DirectoryServiceUpdateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DirectoryServiceUpdateResponse): DirectoryServiceUpdateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.directory.v1.DirectoryView directory_view */ 1:
                    message.directoryView = DirectoryView.internalBinaryRead(reader, reader.uint32(), options, message.directoryView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DirectoryServiceUpdateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.directory.v1.DirectoryView directory_view = 1; */
        if (message.directoryView)
            DirectoryView.internalBinaryWrite(message.directoryView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryServiceUpdateResponse
 */
export const DirectoryServiceUpdateResponse = new DirectoryServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryServiceGetRequest$Type extends MessageType<DirectoryServiceGetRequest> {
    constructor() {
        super("c1.api.directory.v1.DirectoryServiceGetRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => DirectoryExpandMask }
        ]);
    }
    create(value?: PartialMessage<DirectoryServiceGetRequest>): DirectoryServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<DirectoryServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DirectoryServiceGetRequest): DirectoryServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* c1.api.directory.v1.DirectoryExpandMask expand_mask */ 2:
                    message.expandMask = DirectoryExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DirectoryServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* c1.api.directory.v1.DirectoryExpandMask expand_mask = 2; */
        if (message.expandMask)
            DirectoryExpandMask.internalBinaryWrite(message.expandMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryServiceGetRequest
 */
export const DirectoryServiceGetRequest = new DirectoryServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryServiceDeleteRequest$Type extends MessageType<DirectoryServiceDeleteRequest> {
    constructor() {
        super("c1.api.directory.v1.DirectoryServiceDeleteRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<DirectoryServiceDeleteRequest>): DirectoryServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<DirectoryServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DirectoryServiceDeleteRequest): DirectoryServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DirectoryServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryServiceDeleteRequest
 */
export const DirectoryServiceDeleteRequest = new DirectoryServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryServiceDeleteResponse$Type extends MessageType<DirectoryServiceDeleteResponse> {
    constructor() {
        super("c1.api.directory.v1.DirectoryServiceDeleteResponse", []);
    }
    create(value?: PartialMessage<DirectoryServiceDeleteResponse>): DirectoryServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DirectoryServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DirectoryServiceDeleteResponse): DirectoryServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DirectoryServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryServiceDeleteResponse
 */
export const DirectoryServiceDeleteResponse = new DirectoryServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryServiceListRequest$Type extends MessageType<DirectoryServiceListRequest> {
    constructor() {
        super("c1.api.directory.v1.DirectoryServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => DirectoryExpandMask }
        ]);
    }
    create(value?: PartialMessage<DirectoryServiceListRequest>): DirectoryServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<DirectoryServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DirectoryServiceListRequest): DirectoryServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.directory.v1.DirectoryExpandMask expand_mask */ 3:
                    message.expandMask = DirectoryExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DirectoryServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.directory.v1.DirectoryExpandMask expand_mask = 3; */
        if (message.expandMask)
            DirectoryExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryServiceListRequest
 */
export const DirectoryServiceListRequest = new DirectoryServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryServiceListResponse$Type extends MessageType<DirectoryServiceListResponse> {
    constructor() {
        super("c1.api.directory.v1.DirectoryServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DirectoryView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<DirectoryServiceListResponse>): DirectoryServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<DirectoryServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DirectoryServiceListResponse): DirectoryServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.directory.v1.DirectoryView list */ 1:
                    message.list.push(DirectoryView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DirectoryServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.directory.v1.DirectoryView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            DirectoryView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryServiceListResponse
 */
export const DirectoryServiceListResponse = new DirectoryServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryServiceSearchRequest$Type extends MessageType<DirectoryServiceSearchRequest> {
    constructor() {
        super("c1.api.directory.v1.DirectoryServiceSearchRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => DirectoryExpandMask },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DirectoryRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "500" } } } }
        ]);
    }
    create(value?: PartialMessage<DirectoryServiceSearchRequest>): DirectoryServiceSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<DirectoryServiceSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DirectoryServiceSearchRequest): DirectoryServiceSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.directory.v1.DirectoryExpandMask expand_mask */ 4:
                    message.expandMask = DirectoryExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated c1.api.directory.v1.DirectoryRef refs */ 5:
                    message.refs.push(DirectoryRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DirectoryServiceSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.directory.v1.DirectoryExpandMask expand_mask = 4; */
        if (message.expandMask)
            DirectoryExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.directory.v1.DirectoryRef refs = 5; */
        for (let i = 0; i < message.refs.length; i++)
            DirectoryRef.internalBinaryWrite(message.refs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryServiceSearchRequest
 */
export const DirectoryServiceSearchRequest = new DirectoryServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryServiceSearchResponse$Type extends MessageType<DirectoryServiceSearchResponse> {
    constructor() {
        super("c1.api.directory.v1.DirectoryServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DirectoryView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<DirectoryServiceSearchResponse>): DirectoryServiceSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<DirectoryServiceSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DirectoryServiceSearchResponse): DirectoryServiceSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.directory.v1.DirectoryView list */ 1:
                    message.list.push(DirectoryView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DirectoryServiceSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.directory.v1.DirectoryView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            DirectoryView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryServiceSearchResponse
 */
export const DirectoryServiceSearchResponse = new DirectoryServiceSearchResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.directory.v1.DirectoryService
 */
export const DirectoryService = new ServiceType("c1.api.directory.v1.DirectoryService", [
    { name: "Get", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/directories/{app_id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Directory", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "Directory" }] }, "authz.method": { role: "VIEWER" } }, I: DirectoryServiceGetRequest, O: DirectoryServiceGetResponse },
    { name: "List", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/directories", query: { page_size: "page_size", page_token: "page_token" }, terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Directory", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }, { type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Directories", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "Directory", pagination: { type: "TERRAFORM_ENTITY_PAGINATION_TYPE_CURSOR", inputs: [{ name: "pageToken", type: "TERRAFORM_ENTITY_PAGINATION_INPUT_TYPE_CURSOR" }], outputs: { nextCursor: "$.nextPageToken" } } }] }, "authz.method": { role: "VIEWER" } }, I: DirectoryServiceListRequest, O: DirectoryServiceListResponse },
    { name: "Create", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/directories", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Directory" }], group: "Directory" }] }, "authz.method": { role: "EDITOR" } }, I: DirectoryServiceCreateRequest, O: DirectoryServiceCreateResponse },
    { name: "Delete", options: { "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/directories/{app_id}", group: "Directory" }] }, "authz.method": { role: "EDITOR" } }, I: DirectoryServiceDeleteRequest, O: DirectoryServiceDeleteResponse },
    { name: "Update", options: { "apigw.v1.method": { operations: [{ method: "PUT", route: "/api/v1/directories/{app_id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Directory" }], group: "Directory" }] }, "authz.method": { role: "EDITOR" } }, I: DirectoryServiceUpdateRequest, O: DirectoryServiceUpdateResponse },
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: DirectoryServiceSearchRequest, O: DirectoryServiceSearchResponse }
]);
